module.exports = __webpack_public_path__ + "img/banner_bg_EN.a0883a3d.png";